import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApkLoanAssetService = {};

ApkLoanAssetService.addApkLoanAssetService = function (data) {
  return lossClient({
    url: `/ApkLoanAsset/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApkLoanAssetService.editApkLoanAssetService = function (data) {
  return lossClient({
    url: `/ApkLoanAsset/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

ApkLoanAssetService.getRequiredAssetDocService = function (data) {
  const params = new URLSearchParams({
    applicationid: data.applicationid || "",
  });

  return lossClient({
    url: `/ApkLoanAsset/requiredAssetDoc?${params.toString()}`,
    method: "get",
  });
};

ApkLoanAssetService.getRequiredFeesService = function (data) {
  const params = new URLSearchParams({
    applicationid: data.applicationid || "",
  });

  return lossClient({
    url: `/ApkLoanAsset/requiredFees?${params.toString()}`,
    method: "get",
  });
};

ApkLoanAssetService.getAttributeValidationService = function (data) {
  const params = new URLSearchParams({
    chasisno: data.chasisno || "",
    engineno: data.engineno || "",
  });

  return lossClient({
    url: `/ApkLoanAsset/attributeValidation?${params.toString()}`,
    method: "get",
  });
};

ApkLoanAssetService.getEditAssetService = function (data) {
  // console.log("getEditAssetService called with data:", data?.applicationid);

  const pageIndex = data?.pageIndex ?? 0;
  const actualIndex = pageIndex > 0 ? pageIndex - 1 : 0;

  const params = new URLSearchParams();

  if (data?.pageSize) params.append("pageSize", data.pageSize);
  params.append("pageIndex", actualIndex.toString());
  if (data?.applicationid) params.append("applicationId", data.applicationid);
  if (data?.status) params.append("status", data.status);

  return lossClient(`/ApkLoanAsset/getedit?${params.toString()}`, {
    method: "GET",
  });
};

ApkLoanAssetService.getMRPService = function (data) {
  // console.log("getEditAssetService called with data:", data?.applicationid);

  const pageIndex = data?.pageIndex ?? 0;
  const actualIndex = pageIndex > 0 ? pageIndex - 1 : 0;

  const params = new URLSearchParams();

  if (data?.pageSize) params.append("pageSize", data.pageSize);
  params.append("pageIndex", actualIndex.toString());
  if (data?.brandid) params.append("brandid", data.brandid);
  if (data?.brandtype) params.append("brandtype", data.brandtype);
  if (data?.modelid) params.append("modelid", data.modelid);
  if (data?.manufacturingyear)
    params.append("manufacturingyear", data.manufacturingyear);
  if (data?.regionalMRPId) params.append("regionalMRPId", data.regionalMRPId);

  return lossClient(`/ApkLoanAsset/getMRP?${params.toString()}`, {
    method: "GET",
  });
};

export default ApkLoanAssetService;
